module.exports = __webpack_public_path__ + "img/types_bg.57320b19.png";